import type { ReactNode } from "react";
import { Quote } from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./DocumentationWorkspace.module.css";

/** Presentation shared by real workflow results and the isolated builder preview. */
export function WorkflowResultCard({ title, status, children }: { title: ReactNode; status: ReactNode; children: ReactNode }) {
    return <section className={styles.workflowInstance}>
        <header className={styles.workflowInstanceHeader}>
            <h2>{title}</h2>
            <span>{status}</span>
        </header>
        {children}
    </section>;
}

export function WorkflowResultBox({ title, nested = false, children }: { title: ReactNode; nested?: boolean; children: ReactNode }) {
    return <div className={`${styles.workflowNode} ${nested ? styles.subflowStep : ""}`}>
        <div className={styles.workflowNodeHeader}><h3>{title}</h3></div>
        {children}
    </div>;
}

export function WorkflowChoiceResult({ picker, content, children }: { picker: ReactNode; content: string; children?: ReactNode }) {
    return <div>
        {picker}
        <p style={{ whiteSpace: "pre-wrap" }}>{content}</p>
        {children}
    </div>;
}

export function WorkflowEvidence({ spans }: { spans: readonly string[] }) {
    const { t } = useTranslation();
    if (!spans.length) return null;
    return <div className={styles.nodeEvidence}>
        <Quote size={14} />
        <div>
            <strong>{t("documentFlow.evidenceQuoted")}</strong>
            <ul>{spans.map((span, index) => <li key={index}>{span}</li>)}</ul>
        </div>
    </div>;
}
